import React, { useMemo } from 'react';
import { isEmpty } from '@/shared/utility';
import GameCard from '@/pages/games/game-card/GameCard';
import { GamesStreamlineSectionCommonProps } from '@/components/shared/games/GamesStreamlineSection';
import { useLocation } from 'react-router-dom';
import Double from '@/components/shared/streamline/children-layouts/Double';
import Streamline from '@/components/shared/streamline/Streamline';

const indexes = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28];

function GamesDoubleStreamline({
  games,
  category,
}: GamesStreamlineSectionCommonProps): JSX.Element {
  const { pathname } = useLocation();

  const children = useMemo(() => {
    if (isEmpty(games)) return <div />;
    const maxChildIndex = games.length - 1;
    const maxFoundIndex = indexes.findIndex(indexInner => indexInner > maxChildIndex);
    const maxIndex = maxFoundIndex === -1 ? indexes[indexes.length - 1] : maxFoundIndex - 1;

    return indexes.slice(0, maxIndex + 1).map(upperIndex => {
      const lowerIndex = upperIndex + 1;
      const upperGame = games[upperIndex];
      const lowerGame = games[lowerIndex];
      return (
        <Double key={`/${category}/${upperGame.slug}/${upperGame.gameId}`}>
          {upperGame && <GameCard game={upperGame} category={category} />}
          {lowerGame && <GameCard game={lowerGame} category={category} />}
        </Double>
      );
    });
  }, [games, pathname]);

  return <Streamline children={children} />;
}

export default GamesDoubleStreamline;
